// extracted by mini-css-extract-plugin
export default {"Opacity":"Opacity_Opacity__4f3jU"};